import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber'

const pnu = PhoneNumberUtil.getInstance()

export const isValidPhoneNumber = (number: string) => {
  // '0'などをparseしようとするとエラーがでる
  try {
    const parsed = pnu.parse(number, 'JP')

    return pnu.isValidNumberForRegion(parsed, 'JP')
  } catch {
    return false
  }
}

export const formatPhoneNumber = (number: string) => {
  try {
    const parsed = pnu.parse(number, 'JP')

    return pnu.format(parsed, PhoneNumberFormat.NATIONAL)
  } catch {
    return number
  }
}

export const formatPhoneNumberE164 = (number: string) => {
  try {
    const parsed = pnu.parse(number, 'JP')

    return pnu.format(parsed, PhoneNumberFormat.E164)
  } catch {
    return null
  }
}
